import React, { useEffect, useRef, useCallback } from "react";
import { useMediaQuery, } from "@mui/material";

const SplashScreen = ({ onFinish }) => {
  const isMobile = useMediaQuery("(max-width:950px)");
  const pageReadyRef = useRef(false);
  const imagesLoadedRef = useRef(false);
  const minTimePassedRef = useRef(false);
  const startTimeRef = useRef(Date.now());

  // Check if all images on the page are loaded
  const checkImagesLoaded = () => {
    return new Promise((resolve) => {
      const images = document.querySelectorAll('img');

      if (images.length === 0) {
        resolve();
        return;
      }

      let loadedCount = 0;
      const totalImages = images.length;

      const checkComplete = () => {
        if (loadedCount === totalImages) {
          resolve();
        }
      };

      images.forEach((img) => {
        if (img.complete) {
          loadedCount++;
        } else {
          img.addEventListener('load', () => {
            loadedCount++;
            checkComplete();
          });
          img.addEventListener('error', () => {
            loadedCount++;
            checkComplete();
          });
        }
      });

      checkComplete();
    });
  };

  // Only finish once all conditions are met
  const tryFinish = useCallback(async () => {
    if (!pageReadyRef.current) return;

    // Wait for images to load
    await checkImagesLoaded();
    imagesLoadedRef.current = true;

    // Calculate remaining time to reach 3 seconds minimum
    const elapsedTime = Date.now() - startTimeRef.current;
    const remainingTime = Math.max(0, 3000 - elapsedTime);

    // Wait for minimum 3 seconds total
    setTimeout(() => {
      minTimePassedRef.current = true;
      if (pageReadyRef.current && imagesLoadedRef.current && minTimePassedRef.current) {
        onFinish();
      }
    }, remainingTime);
  }, [onFinish]);

  useEffect(() => {
    // Expose a method for parent to signal page is ready
    window.__splashPageReady = () => {
      pageReadyRef.current = true;
      tryFinish();
    };

    return () => {
      delete window.__splashPageReady;
    };
  }, [tryFinish]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#000000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        zIndex: 9999,
      }}
    >
      <div style={{ width: isMobile ? "40%" : "20%", maxWidth: "580px", display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
        <img src="/icons/cateye2.gif" alt="Loading" />
        <div style={{ color: "#F9B04E", fontSize: isMobile ? "1rem" : "1.5rem", fontFamily: "Helvetica !important", display: "flex", alignSelf: "center", gap: "1rem" }}>
          L O A D I N G
        </div>
      </div>
      <div style={{ color: "#929292", fontSize: "21px", fontFamily: "Helvetica !important", fontWeight: "bold",  position: "absolute", bottom: isMobile ? "4rem" : "2rem",}}>
        Powered by Pet Pet Club Limited
      </div>
    </div>
  );
};

export default SplashScreen;
